import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { HideLoader, ShowLoader } from '../actions/loader.actions';

@Injectable()
export class LoaderEffects {
  constructor(private actions$: Actions) {}

  showLoader$ = createEffect(() =>
    this.actions$.pipe(
      filter(this.getShowLoaderTriggerAction),
      map(this.createShowLoaderAction),
    ),
  );

  hideLoader$ = createEffect(() =>
    this.actions$.pipe(
      filter(this.getHideLoaderTriggerAction),
      map(this.createHideLoaderAction),
    ),
  );

  private getShowLoaderTriggerAction(action: Action) {
    // TODO: get rid of 'as any'
    return action && (action as any).showLoader;
  }

  private getHideLoaderTriggerAction(action: Action) {
    // TODO: get rid of 'as any'
    return action && (action as any).triggerActionType;
  }

  private createShowLoaderAction(action: Action) {
    return new ShowLoader(action);
  }

  private createHideLoaderAction(action: Action) {
    return new HideLoader(action);
  }
}
